import React, { useEffect, useState } from 'react';

const useProfile = () => {
    const [user, setUser] = useState({});

    useEffect(() => {
        fetch('https://one0m-backend2.onrender.com/auth/singleUser', {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json())
            .then(data => setUser(data))
    }, [user])

    return [user]

}

export default useProfile;